module.exports = __webpack_public_path__ + "media/steps/car_bcg@2x-466753e0.png";